import React from 'react'

const SlideFive = () => (
  <div className="slide">
    <div className="slide-inner">
      <div className="slide-left">
        <h2>Opportunity</h2>
        <p>
          Capturing the market share
        </p>
        <small>*Metrics as of December 1, 2020</small>
      </div>
      <div className="slide-right">
        <h3>Uniswap</h3>
        <p>▶ Market Cap: $875,000,000+</p>
        <p>▶ Daily Trading Volume: $350,000,00+</p>
        <h3>Sushiwap</h3>
        <p>▶ Market Cap: $250,000,000+</p>
        <p>▶ Daily Trading Volume: $325,000,00+</p>
      </div>
    </div>
  </div>
)

export default SlideFive
